export default __webpack_public_path__ + "static/media/edit-image.79fc9c35.svg";